import React, { Component } from 'react';
import PropTypes from 'prop-types';
import querystring from 'querystring';
import moment from 'moment';
import { connect } from 'react-redux';
import Icon from '../common/icons/Icon';
import Breadcrumb from '../common/components/Breadcrumb';
import VideoUploader from '../common/components/VideoUploader';
import VideoPlayer from '../common/video/VideoPlayer';
import { selectActivePendingReviewSubmittal, selectActiveHistorySubmittal } from './selectors';
import {
  getResponseVideoForCompletedSubmittal,
  getResponseVideoForPendingSubmittal,
  submitSwingReview,
  uploadVideo,
} from './actions';

class SwingSubmittalReviewPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    initialValues: PropTypes.object,
  };

  componentDidMount() {
    const { activeSubmittal, dispatch, match: { params: { id } } } = this.props;
    if (activeSubmittal.get('response_video_id') && !activeSubmittal.get('response')) {
      const getResponseVideoAction = activeSubmittal.get('responded_by')
        ? getResponseVideoForCompletedSubmittal(id)
        : getResponseVideoForPendingSubmittal(id);

      dispatch(getResponseVideoAction).then(this.handleVideoResponse);
    }
  }

  checkVideoStatus = () => {
    const { dispatch, match: { params: { id } } } = this.props;

    dispatch(getResponseVideoForPendingSubmittal(id)).then(this.handleVideoResponse);
  };

  handleVideoResponse = response => {
    if (response.json && response.json.transcode_status !== 'Complete' && response.json.transcode_status !== 'Error') {
      setTimeout(this.checkVideoStatus, 10000);
    }
  };

  onVideoUpload = file => {
    const { dispatch, match: { params: { id } } } = this.props;

    return dispatch(uploadVideo(id, file[0])).then(response => {
      setTimeout(this.checkVideoStatus, 10000);
    });
  };

  onSubmitSwingReview = () => {
    const { dispatch, match: { params: { id } } } = this.props;

    return dispatch(submitSwingReview(id)).then(action => {
      if (action.response.ok) {
        this.props.history.push('/swing-submittals');
      }
    });
  };

  render() {
    const {
      activeSubmittal,
      submitSwingReview,
      swingResponseUploading,
      swingResponseUploadProgress,
      location,
    } = this.props;

    if (!activeSubmittal) {
      return null;
    }

    const breadcrumbs = [
      {
        label: 'Swing Submittals',
        to: `/swing-submittals${location.search}`,
      },
      {
        label: `${activeSubmittal.getIn(['submittedBy', 'name'])} (${activeSubmittal.getIn([
          'type',
          'short_name',
        ])}) - ${moment(activeSubmittal.get('updated_at')).format('M/D/YY')}`,
        to: null,
      },
    ];
    const isCompleted = !!activeSubmittal.get('respondedBy');

    return (
      <div className="admin-paper">
        <div className="admin-paper__header">
          <Breadcrumb crumbs={breadcrumbs} />
        </div>
        <div className="admin-paper__edit-content swing-admin-content">
          <div className="download-container">
            <h4>Swing Submittal</h4>
            <a className="button button--icon button--theme--inverse" href={activeSubmittal.get('swing')} download>
              <Icon icon="Download" />Download Video
            </a>
          </div>
          <h4>Upload your response</h4>
          {isCompleted ? (
            <div className="admin__image-preview">
              <VideoPlayer video={activeSubmittal.get('response')} />
            </div>
          ) : (
            <VideoUploader
              onVideoUpload={this.onVideoUpload}
              uploading={swingResponseUploading}
              uploadProgress={swingResponseUploadProgress}
              video={activeSubmittal.get('response_video_id') ? activeSubmittal.get('response') : null}
              labelText=""
            />
          )}
          {!isCompleted && (
            <button
              type="button"
              className="button"
              disabled={
                !activeSubmittal.get('response') ||
                activeSubmittal.getIn(['response', 'transcode_status']) !== 'Complete' ||
                submitSwingReview.get('loading')
              }
              onClick={this.onSubmitSwingReview}
            >
              Submit Swing Review
            </button>
          )}
        </div>
      </div>
    );
  }
}

export default connect((state, ownProps) => {
  const { search } = ownProps.location;
  const qs = search ? querystring.parse(search.slice(1)) : {};

  const activeSubmittalSelector = qs.viewHistory ? selectActiveHistorySubmittal : selectActivePendingReviewSubmittal;

  return {
    activeSubmittal: activeSubmittalSelector(state, ownProps.match.params.id),
    submitSwingReview: state.swingSubmittals.submitSwingReview,
    swingResponseUploading: state.swingSubmittals.swingResponseUploading,
    swingResponseUploadProgress: state.swingSubmittals.swingResponseUploadProgress,
  };
})(SwingSubmittalReviewPage);



// WEBPACK FOOTER //
// ./src/swing-submittals/SwingSubmittalReviewPage.js